/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TravelInputs */

const en_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel`)
};

const es_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viajes`)
};

const fr_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyage`)
};

const de_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reise`)
};

const ja_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行`)
};

const zh_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行摄影`)
};

const ar_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير رحلات`)
};

const id_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perjalanan`)
};

const it_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viaggio`)
};

const ru_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путешествия`)
};

const pt_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viagem`)
};

const ko_val_travel = /** @type {(inputs: Val_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여행`)
};

/**
* | output |
* | --- |
* | "Travel" |
*
* @param {Val_TravelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_travel = /** @type {((inputs?: Val_TravelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TravelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_travel(inputs)
	if (locale === "es") return es_val_travel(inputs)
	if (locale === "fr") return fr_val_travel(inputs)
	if (locale === "de") return de_val_travel(inputs)
	if (locale === "ja") return ja_val_travel(inputs)
	if (locale === "zh") return zh_val_travel(inputs)
	if (locale === "ar") return ar_val_travel(inputs)
	if (locale === "id") return id_val_travel(inputs)
	if (locale === "it") return it_val_travel(inputs)
	if (locale === "ru") return ru_val_travel(inputs)
	if (locale === "pt") return pt_val_travel(inputs)
	return ko_val_travel(inputs)
});